import React, { useRef } from "react";
import { ScheduleContext } from "./ScheduleContext";
import AppLayout from "./AppLayout";
import Screen from "../Screen/Screen";
// import { StateInspector } from "reinspect";

export default function App({ scheduleData }) {

  const ref = useRef(null);

  return (
    <div className="bootstrap-react" ref={ref}>
      {/* <StateInspector> */}
      <ScheduleContext.Provider value={scheduleData}>
        <AppLayout>
          <Screen topRef={ref} />
        </AppLayout>
      </ScheduleContext.Provider>
      {/* </StateInspector> */}
    </div>
  );
}
